import authHeader from "utils/auth-header";
import { IConcreteBaseInputsResponse } from "../domain/IConcreteBaseInputsResponse";
import { IGetConcreteBaseInputsRequestParams } from "../domain/IGetConcreteBaseInputsRequestParams";
import API from "utils/API";
import { getQeuryParams } from "utils/queryParamsUtil";
import { IConcreteBaseInputCreate } from "../domain/IConcreteBaseInputCreate";
import { IConcreteBaseInput } from "../domain/IConcreteBaseInput";
import { IResponseConcreteBaseItems } from "../domain/IResponseConcreteBaseItems";
import { IConcreteBaseItem } from "../domain/IConcreteBaseItem";
import { IRepository } from "../domain/IRepository";
import { IResponseRepositories } from "../domain/IResponseRepositories";
import { IConcreteBaseOutputCreate } from "../domain/IConcreteBaseOutputCreate";
import { IMessage } from "domain/IMessage";
import { IOutputSearch } from "../domain/IOutputSearch";
import { IOutputsResponse } from "../domain/IOutputsResponse";
import { IProduceItem } from "../domain/IProduceItem";
import { IConcreteBaseInputUpdate } from "../domain/IConcreteBaseInputUpdate";
import { IConcreteBaseProducedItemResponse } from "../domain/IConcreteBaseProduceItemResponse";
import { IConcreteBaseInputItemUpdate } from "../domain/IConcreteBaseInputItemUpdate";
import { IConcreteBaseInputItemCreate } from "../domain/IConcreteBaseInputItemCreate";
import { IOutputForPrint } from "../domain/IOutputForPrint";
import { IOutputReportForPrint } from "../domain/IOutputReportForPrint";
import { IGetOutputReportRequestParams } from "../domain/IGetOutputReportRequestParams";
import { IConcreteBaseUpdateInputItemResponse } from "../domain/IConcreteBaseUpdateInputItemResponse";
import { IConcreteBaseOutputUpdate } from "../domain/IConcreteBaseOutputUpdate";
import { IGetPageRequestParams } from "hooks/pagingAndSort";

const getRepositoriesForConcreteBase = async (): Promise<IRepository[]> => {
  var headers = authHeader();
  try {
    const response = await API.get<IResponseRepositories>(
      "/concrete-base/public/repository",
      { headers }
    );
    let repositories = response.data.repositories;
    return repositories;
  } catch (err) {
    throw err;
  }
};

const getConcreteBaseInputs = async (
  data: IGetConcreteBaseInputsRequestParams,
  pagingData: IGetPageRequestParams,
  signal: AbortSignal
): Promise<IConcreteBaseInputsResponse> => {
  var headers = authHeader();
  try {
    const response = await API.get<IConcreteBaseInputsResponse>(
      `/concrete-base/public/input${getQeuryParams({ ...data, ...pagingData })}`,
      { headers, signal }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const createConcreteBaseInput = async (
  data: IConcreteBaseInputCreate
): Promise<IConcreteBaseInput> => {
  var headers = authHeader();
  try {
    const response = await API.post<IConcreteBaseInput>(
      "/concrete-base/public/input",
      data,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const updateConcreteBaseInput = async (
  data: IConcreteBaseInputUpdate
): Promise<IConcreteBaseInput[]> => {
  var headers = authHeader();
  try {
    const { inputId, ...rest } = data;
    const response = await API.put<IConcreteBaseInput[]>(
      `/concrete-base/public/input/${inputId}`,
      { ...rest },
      { headers }
    );
    let concreteBaseInput = response.data;
    return concreteBaseInput;
  } catch (err) {
    throw err;
  }
};

const getConcreteBaseInputItems = async (isOwnProduct: boolean): Promise<IConcreteBaseItem[]> => {
  var headers = authHeader();
  try {
    const queryParams = isOwnProduct !== undefined ? `?isOwnProduct=${isOwnProduct}` : "";
    const response = await API.get<IResponseConcreteBaseItems>(
      `/concrete-base/public/input/item${queryParams}`,
      { headers }
    );
    return response.data.items;
  } catch (err) {
    throw err;
  }
};

const createConcreteBaseInputItem = async (data: IConcreteBaseInputItemCreate): Promise<IConcreteBaseItem> => {
  var headers = authHeader();
  try {
    const response = await API.post<IConcreteBaseItem>(
      "/concrete-base/public/input/item",
      data,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const updateConcreteBaseInputItem = async (data: IConcreteBaseInputItemUpdate): Promise<IConcreteBaseUpdateInputItemResponse> => {
  var headers = authHeader();
  try {
    const { inputItemId, ...rest } = data;
    const response = await API.put<IConcreteBaseUpdateInputItemResponse>(
      `/concrete-base/public/input/item/${inputItemId}`,
      { ...rest },
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const produceOwnItem = async (
  producedItem: IProduceItem
): Promise<IConcreteBaseProducedItemResponse> => {
  var headers = authHeader();
  try {
    const response = await API.post<IConcreteBaseProducedItemResponse>(
      "/concrete-base/public/produce-item",
      producedItem,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const importProducedItem = async (
  producedItem: any
): Promise<IConcreteBaseProducedItemResponse> => {
  var headers = authHeader();

  try {
    let formData = new FormData();

    formData.append("producedItemId", producedItem.producedItemId);
    formData.append("producedItemCode", producedItem.producedItemCode);
    formData.append("unit", producedItem.unit);
    formData.append("quantity", producedItem.quantity);
    formData.append("price", producedItem.price);

    // Convert usedInputsData to a proper file
    const usedInputsFile = new File(
      [JSON.stringify(producedItem.usedInputsData)],
      'usedInputsData.tsv',
      { type: 'text/tab-separated-values' }
    );
    formData.append("usedInputsData", usedInputsFile);

    const response = await API.post<IConcreteBaseProducedItemResponse>(
      "/concrete-base/public/import-produced-item",
      producedItem,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const createOutputProject = async (
  output: IConcreteBaseOutputCreate
): Promise<IMessage> => {
  var headers = authHeader();
  try {
    const response = await API.post<IMessage>(
      "/concrete-base/public/output-for-project",
      output,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const createOutputPartner = async (
  output: IConcreteBaseOutputCreate
): Promise<IMessage> => {
  var headers = authHeader();
  try {
    const response = await API.post<IMessage>(
      "/concrete-base/public/output-for-partner",
      output,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getOutputs = async (
  search: IOutputSearch,
  pagingData: IGetPageRequestParams,
  signal: AbortSignal
): Promise<IOutputsResponse> => {
  var headers = authHeader();
  try {
    const response = await API.get<IOutputsResponse>(
      `/concrete-base/public/output${getQeuryParams({ ...search, ...pagingData })}`,
      { headers, signal }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const updateConcreteBaseOutput = async (data: IConcreteBaseOutputUpdate): Promise<IOutputForPrint> => {
  var headers = authHeader();
  try {
    const { outputId, ...rest } = data;
    const response = await API.put<IOutputForPrint>(
      `/concrete-base/public/output/${outputId}`,
      { ...rest },
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getOutputForPrint = async (
  outputId: number
): Promise<IOutputForPrint> => {
  var headers = authHeader();
  try {
    const response = await API.get<IOutputForPrint>(
      `/concrete-base/public/output/${outputId}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getOutputReportForPrint = async (
  params: IGetOutputReportRequestParams
): Promise<IOutputReportForPrint> => {
  var headers = authHeader();
  try {
    const response = await API.get<IOutputReportForPrint>(
      `/concrete-base/public/output/report${getQeuryParams(params)}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const deleteConcreteBaseOutput = async (
  outputId: number
): Promise<{ deletedOutputIds: number[] }> => {
  var headers = authHeader();
  try {
    const response = await API.delete<{ deletedOutputIds: number[] }>(
      `/concrete-base/public/output/${outputId}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const concreteBaseService = {
  getRepositoriesForConcreteBase,
  getConcreteBaseInputs,
  createConcreteBaseInput,
  updateConcreteBaseInput,
  getConcreteBaseInputItems,
  createConcreteBaseInputItem,
  updateConcreteBaseInputItem,
  updateConcreteBaseOutput,
  produceOwnItem,
  importProducedItem,
  createOutputProject,
  createOutputPartner,
  getOutputs,
  getOutputForPrint,
  getOutputReportForPrint,
  deleteConcreteBaseOutput,
};
